import React from "react";
import { Reset } from "styled-reset";
import ThemeProvider from "./src/styles/provider";
export const wrapPageElement = ({ element, props }) => {
  return /* @__PURE__ */ React.createElement(ThemeProvider, null, /* @__PURE__ */ React.createElement(Reset, null), element);
};
